import { useState } from "react";
import { IonIcon } from "@ionic/react";
import { menuOutline, closeOutline } from "ionicons/icons";
import logo from "./assets/images/logo.png";
import uk from "./assets/images/uk-logo.png";
import { NavLink } from "react-router-dom";

const Navbar = () => {
    const [menuOpen, setMenuOpen] = useState(false);

    const toggleMenu = () => {
        setMenuOpen(!menuOpen);
    };

    const handleLinkClick = () => {
        if (menuOpen) {
            toggleMenu();
        }
    };

    return (
        <header className="bg-white py-6 overflow-x-hidden mb-8">
            <nav className="flex justify-between bg-white shadow-md items-center py-6 md:px-[3%] px-[8%] w-full mx-0 px-[10%] z-[9999] fixed top-0 left-0">
                <div className="cursor-pointer hover:scale-[1.1] duration-300 ease-in-out">
                    <NavLink to="/">
                        <div className="w-[100px]">
                            <img src={logo} alt="logo" className="" />
                        </div>
                    </NavLink>
                </div>

                <div className={`nav-links duration-500 md:static absolute md:min-h-fit min-h-[60vh] left-0 ${menuOpen ? "top-[80%] min-h-[30vh] backdrop-blur-md white/30 gz-10 py-4" : "top-[-900%]"} md:w-auto w-full flex items-center px-5`}>
                    <div className="pl-12 flex md:flex-row flex-col md:items-center md:gap-[4vw] gap-6 w-full justify-between">
                        <ul className="flex md:flex-row flex-col md:pr-16 md:items-center md:gap-[4vw] gap-4">
                            <li>
                                <NavLink
                                    to="/"
                                    className={({ isActive }) =>
                                        `group relative inline-block py-2 md:px-2 px-5 focus:text-[#0d438d] ${isActive ? 'text-[#0d438d]' : 'hover:text-[#0d438d]'}`
                                    }
                                    onClick={handleLinkClick}
                                >
                                    {({ isActive }) => (
                                        <>
                                            Home
                                            <span className={`absolute bottom-0 left-0 h-[3px] bg-gradient-to-r from-[#d81d83] to-[#2AD5FF] rounded-full transition-all duration-300 ${
                                                isActive ? 'w-full' : 'w-0 group-hover:w-full'
                                            }`}></span>
                                        </>
                                    )}
                                </NavLink>
                            </li>

                            <li>
                                <NavLink
                                    to="/about"
                                    className={({ isActive }) =>
                                        `group relative inline-block py-2 md:px-2 px-5 focus:text-[#0d438d] ${isActive ? 'text-[#0d438d]' : 'hover:text-[#0d438d]'}`
                                    }
                                    onClick={handleLinkClick}
                                >
                                    {({ isActive }) => (
                                        <>
                                            About
                                            <span className={`absolute bottom-0 left-0 h-[3px] bg-gradient-to-r from-[#d81d83] to-[#2AD5FF] rounded-full transition-all duration-300 ${
                                                isActive ? 'w-full' : 'w-0 group-hover:w-full'
                                            }`}></span>
                                        </>
                                    )}
                                </NavLink>
                            </li>

                            <li>
                                <NavLink
                                    to="/contact"
                                    className={({ isActive }) =>
                                        `group relative inline-block py-2 md:px-2 px-5 focus:text-[#0d438d] ${isActive ? 'text-[#0d438d]' : 'hover:text-[#0d438d]'}`
                                    }
                                    onClick={handleLinkClick}
                                >
                                    {({ isActive }) => (
                                        <>
                                            Contact
                                            <span className={`absolute bottom-0 left-0 h-[3px] bg-gradient-to-r from-[#d81d83] to-[#2AD5FF] rounded-full transition-all duration-300 ${
                                                isActive ? 'w-full' : 'w-0 group-hover:w-full'
                                            }`}></span>
                                        </>
                                    )}
                                </NavLink>
                            </li>
                        </ul>

                        <ul className="flex md:flex-row flex-col md:items-center md:gap-[1vw] gap-4">
                            <li>
                                <NavLink
                                    to="en"
                                    className={({ isActive }) =>
                                        `group relative inline-block py-2 px focus:text-[#0d438d] ${isActive ? 'text-[#0d438d]' : 'hover:text-[#0d438d]'}`
                                    }
                                    onClick={handleLinkClick}
                                >
                                    {({ isActive }) => (
                                        <div className="flex gap-1 px-4">
                                            <img src={uk} alt="en" className="pt-1 pr-1 w-[20px] h-[19px]" />
                                            <span className="text-sm text-[.8rem] font-[500]">EN</span>
                                            <span className={`absolute bottom-0 left-0 h-[3px] bg-gradient-to-r from-[#d81d83] to-[#2AD5FF] rounded-full transition-all duration-300 ${
                                                isActive ? 'w-full' : 'w-0 group-hover:w-full'
                                            }`}></span>
                                        </div>
                                    )}
                                </NavLink>
                            </li>

                            <li>
                                <NavLink
                                    to="https://app.fastest.exchange/login"
                                    className={({ isActive }) =>
                                        `group relative inline-block py-2 md:px-2 px-5 focus:text-[#0d438d] ${isActive ? 'text-[#0d438d]' : 'hover:text-[#0d438d]'}`
                                    }
                                    onClick={handleLinkClick}
                                >
                                    {({ isActive }) => (
                                        <>
                                            Login
                                            <span className={`absolute bottom-0 left-0 h-[3px] bg-gradient-to-r from-[#d81d83] to-[#2AD5FF] rounded-full transition-all duration-300 ${
                                                isActive ? 'w-full' : 'w-0 group-hover:w-full'
                                            }`}></span>
                                        </>
                                    )}
                                </NavLink>
                            </li>

                            <li>
                                <NavLink
                                    to="https://app.fastest.exchange/sign-up"
                                    className="bg-[var(--primary-color)] py-2 px-5 text-white rounded-md hover:bg-[#264876]"
                                    onClick={handleLinkClick}
                                >
                                    Register
                                </NavLink>
                            </li>
                        </ul>
                    </div>
                </div>

                <div className="flex items-center gap-6 md:hidden">
                    <IonIcon
                        icon={menuOpen ? closeOutline : menuOutline}
                        className="text-3xl cursor-pointer text-gray-800"
                        onClick={toggleMenu}
                    />
                </div>
            </nav>
        </header>
    );
};

export default Navbar;
